import { Headers, Method, callFetch } from ".";
import { toErrorPayload } from "../../../helpers/errorPayload";
import { SERVER_ERROR_MESSAGE, API_HOST_ERROR_MESSAGE } from "../../../constants/errorMessages";
import { ApplicationState } from "../../nissan_no";
import { BrandsEnum } from "../../../enums";

const Purchase = async (state: ApplicationState, dispatch?: Function): Promise<ApplicationState> => {
  const { apiHost, quoteId } = state.inputs;

  const email = state.profile?.email.value;
  const phone = state.profile?.phone.value;

  const selectedBonus = state.bonus?.bonus?.availableBonuses?.find(b => b.id === state.bonus?.bonus?.selectedId);
  const bonusOriginNeeded = selectedBonus?.bonusOriginNeeded === "Mandatory";
  const bonusOrigin = bonusOriginNeeded
    ? {
      insuranceCompanyIdentifier: state.bonus?.previousCompany?.selected,
      insuranceCompanyName:
        state.bonus?.previousCompany.selected === "XXXX" ? state.bonus.previousCompany.companyInput?.value : undefined,
      bonusVehicleRegistrationNumber:
        state.bonus?.registrationNumber.selected ?? false ? state.bonus?.registrationNumber.regNumber.value : undefined,
    }
    : undefined;

  let selectedFinanceCompanyId = undefined;
  const selectedFinanceTypeId = state.financingOptions?.selectedFinanceTypeId;
  if (selectedFinanceTypeId && selectedFinanceTypeId !== "2") {
    selectedFinanceCompanyId = state.financingOptions?.selectedCompanyId ?? undefined;
  }

  if (!apiHost) {
    if (dispatch)
      dispatch({
        type: "SET_SERVER_ERROR",
        payload: toErrorPayload({ message: API_HOST_ERROR_MESSAGE, header: SERVER_ERROR_MESSAGE }),
      });
    throw toErrorPayload({ message: API_HOST_ERROR_MESSAGE, header: SERVER_ERROR_MESSAGE });
  }

  if (!state.inputs.partner) {
    throw Error("PARTNER ERROR");
  }

  const data = {
    quoteId: quoteId,
    policyHolderContactInformation: {
      mobilePhoneNumber: phone,
      email: email,
    },
    bonusOrigin,
  };

  let dataToSend = {};

  if (state.inputs.partner === BrandsEnum.VolviaNo) {
    if (selectedFinanceTypeId) {
      if (selectedFinanceTypeId === "0" && selectedFinanceCompanyId) {
        dataToSend = {
          ...data,
          leasing: {
            leasingCompanyId: selectedFinanceCompanyId,
          },
        };
      } else if (selectedFinanceTypeId === "1" && selectedFinanceCompanyId) {
        dataToSend = {
          ...data,
          loan: {
            lenderCompanyId: selectedFinanceCompanyId,
          },
        };
      } else {
        dataToSend = {
          ...data,
        };
      }
    }
  } else {
    // Nissan No
    dataToSend = {
      ...data,
    };
  }

  const fetchBuilder = () =>
    fetch(`${apiHost}/api/no/${state.inputs.partner}/purchase`, {
      method: Method,
      mode: "cors",
      headers: Headers,
      body: JSON.stringify(dataToSend),
    });

  const response = await callFetch(fetchBuilder);

  const json = await response.json();

  if (response.status !== 200 && response.status !== 201 && response.status !== 202) {
    const message = (json && json.message) ?? SERVER_ERROR_MESSAGE;
    if (dispatch)
      dispatch({
        type: "SET_SERVER_ERROR",
        payload: toErrorPayload({ message, header: SERVER_ERROR_MESSAGE }),
      });
    throw toErrorPayload({ message, header: SERVER_ERROR_MESSAGE });
  }

    sessionStorage.removeItem("store");

  return {
    ...state,
    payment: {
      paymentAgreementCreationInstructions: json.paymentOptions.paymentAgreementCreationInstructions,
      paymentFrequencyAndMethodNo: json.paymentOptions.paymentFrequencyAndMethodNo,
      startDate: new Date(Date.parse(json.startDate)),
    },
  };
};

export default Purchase;
